import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import { Button } from "react-md";
import MGridForm from "components/Shared/MGridForm";
import { DATA_TYPE_DATE } from "typeConstants/dataTypes";
import { getPNXFormExportData, savePNXFormExportData } from "actions/homeowner/caseforms";
import get1004dFormDefinition from "components/Shared/MGridFormDefinitions/get1004dFormDefinition";
import moment from "moment-timezone";

class Appraisal1004d extends Component {
  constructor(props) {
    super(props);

    this.getFormData = this.getFormData.bind(this);
    this.saveFormData = this.saveFormData.bind(this);

    this.onFormChange = this.onFormChange.bind(this);
    this.getDateFields = this.getDateFields.bind(this);

    this.mcardControlMethods = null;
    this.modifiedFormData = null;
    this.changedFormFields = [];

    this.formControlMethods = null;

    this.state = {
      formData: null,
      shouldRenderGridForm: true,
    };
  }

  componentDidMount() {
    this.props.getPNXFormExportData(this.props.controlNumber);
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.isFetchingPNXFormExportData && !this.props.isFetchingPNXFormExportData)
        || (prevProps.isSavingPNXFormExportData && !this.props.isSavingPNXFormExportData)
    ) {
      this.setState({ formData: this.getFormData(this.props.dataForPNXFormExportData) });
    }
  }

  getDateFields() {
    return get1004dFormDefinition.flat().filter(f => f.dataType === DATA_TYPE_DATE).map(f => f.source);
  }

  // getRepeatIds() {
  //   return ["FA-380", "FN-381", "FN-382", "FA-383"];
  // }

  getFormData(form) {
    if (!form) return null;

    let dates = this.getDateFields();

    //take YYYY-MM-DD pnx dates and make them MM-DD-YYYY
    let fixDate = d => {
      let split = d.split("-");
      return [split[1], split[2], split[0]].join("/");
    };

    let flattened = form.controls.reduce((acc, val) => {
      acc[val.id] = val.value;

      if (dates.indexOf(val.id) >= 0 && typeof val.value === "string") {
        acc[val.id] = fixDate(val.value);
      }

      return acc;
    }, {});

    return flattened;
  }

  saveFormData() {
    if (!this.formControlMethods.isFormValid()) alert("Form has validation errors. Please fix the errors highlighted in red");
    if (!this.modifiedFormData && this.changedFormFields.length > 0) return;

    let dates = this.getDateFields();
    let fixDate = d => moment(new Date(d)).format("YYYY-MM-DD");

    let modifiedData = {
      controls: this.changedFormFields.map(f => {
        let obj = { id: f, value: this.modifiedFormData[f] };
        if (dates.indexOf(f) >= 0 && typeof obj.value === "string") obj.value = fixDate(obj.value);
        return obj;
      })
    };

    this.props.savePNXFormExportData(this.props.controlNumber, "1004D_SURVEY", modifiedData, () => {
      if (this.props.onSave) this.props.onSave();
    });
  }

  onFormChange(o, source, type, value, changedFields) {
    this.modifiedFormData = o;
    this.changedFormFields = [...new Set([...changedFields, ...this.changedFormFields])];
    if (this.props.onChange) this.props.onChange();
  }

  render() {
    return (
      this.state.shouldRenderGridForm &&
      <div className="appraisal-1004p-mgridform">
        <div className="appraisal-1004p-mgridform-save">
          <Button
            onClick={this.saveFormData}
            primary
            raised
          >
            Save
          </Button>
        </div>
        <div className="appraisal-1004p-mgridform-form">
          <MGridForm
            width={1200}
            data={this.state.formData}
            onChange={this.onFormChange}
            formDefinition={get1004dFormDefinition}
            getControlMethods={cm => this.formControlMethods = cm} />
        </div>
      </div>
    );
  }
}

Appraisal1004d.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  getPNXFormExportData: PropTypes.func.isRequired,
  savePNXFormExportData: PropTypes.func.isRequired,
  isFetchingPNXFormExportData: PropTypes.bool,
  isSavingPNXFormExportData: PropTypes.bool,
  dataForPNXFormExportData: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isFetchingPNXFormExportData: state.caseForms.isFetchingPNXFormExportData,
  isSavingPNXFormExportData: state.caseForms.isSavingPNXFormExportData,
  dataForPNXFormExportData: state.caseForms.dataForPNXFormExportData,
});

const mapDispatchToProps = (dispatch) => ({
  getPNXFormExportData(controlNumber) {
    dispatch(getPNXFormExportData(controlNumber));
  },
  savePNXFormExportData(controlNumber, availFormId, modifiedData, callback) {
    dispatch(savePNXFormExportData(controlNumber, availFormId, modifiedData, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Appraisal1004d);
